import React from 'react';
import Rating from 'react-rating';
interface RatingProps {
  rating: number;
  count?: number;
  showRating?: boolean;
  onClick?: (value: number) => void;
  emptySymbol?: string | JSX.Element;
  fullSymbol?: string | JSX.Element;
}

export const RatingNumber: React.FC<RatingProps> = ({
  rating,
  count,
  showRating = false,
  onClick,
  emptySymbol = 'fa fa-star-o fa-sm',
  fullSymbol = 'fa fa-star fa-sm',
}) => {
  return (
    <div className="flex items-center gap-2">
      {showRating && (
        <div className="text-sm font-medium text-gray-700">{rating}</div>
      )}
      <Rating
        emptySymbol={emptySymbol}
        fullSymbol={fullSymbol}
        fractions={2}
        initialRating={rating}
        readonly={!onClick}
        onClick={onClick}
      />
      {count && (
        <div className="text-sm font-medium text-gray-500">{count}</div>
      )}
    </div>
  );
};

export default Rating;
